module.exports = "<div id=\"category-filter\" class=\"aside__filters\">\r\n  <div class=\"widget__products widget__aside\">\r\n    <h6 class=\"widget__title bg-base text-uppercase bg-gradient w700\">Líneas de Productos</h6>\r\n    <div class=\"widget__wrapper widget__accordion\">\r\n      <categories-accordion items=\"$ctrl.shCtrl.globalCategoriesMenu[0].hijas\"></categories-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/categories-slider-filter/templates/categories-slider-filter-t1.view.html
 ** module id = 390
 ** module chunks = 0
 **/